/**
 * 获取首页数据
 */
import request from "_private/utils/request";
// 车辆变化趋势
export function fetchVelTrendData() {
  return request({
    headers: {
      type: "json"
    },
    method: "post",
    url: "/board/home/vehicleDataAnalysis"
  });
}
// 冷链车辆
export function fetchColdVelData() {
  return request({
    headers: {
      type: "json"
    },
    method: "post",
    url: "/board/home/coldvehicleTypeCount"
  });
}
// 仓库数据
export function fetchStorageData() {
  return request({
    headers: {
      type: "json"
    },
    method: "post",
    url: "/board/home/coldStorageDataAnalysis"
  });
}
// 冷库变化趋势数据
export function fetchStorageChangeData() {
  return request({
    headers: {
      type: "json"
    },
    method: "post",
    url: "/board/home/findOnlineAndQualifyRateByDay"
  });
}
// 冷链数据
export function fetchStorageInOutData() {
  return request({
    headers: {
      type: "json"
    },
    method: "post",
    url: "/board/home/coldStorageTop"
  });
}
// 区域进出数据
export function getInOutAreaFlow() {
  return request({
    headers: {
      type: "json"
    },
    method: "post",
    url: "/board/guangzhouColdMonitor/getInOutAreaFlow"
  });
}
// 车辆、企业等汇总数据
export function fetchNumberByRealTime() {
  return request({
    headers: {
      type: "json"
    },
    method: "post",
    url: "/board/home/findNumberByRealTime"
  });
}
// 车辆、企业等汇总数据
export function fetchMapData() {
  return request({
    headers: {
      type: "json"
    },
    method: "post",
    url: "/board/home/findMapLonLat"
  });
}
// 实时查询各区县下企业、车辆、冷库、冷柜个数接口
export function FetchNumberByAreaName(data) {
  return request({
    headers: {
      type: "json"
    },
    method: "post",
    url: "/board/home/findNumberByAreaName",
    data
  });
}
// 各地区企业数排行及占比接口
export function FetchCompanyNumAndRateByAreaName() {
  return request({
    headers: {
      type: "json"
    },
    method: "post",
    url: "/board/home/findCompanyNumAndRateByAreaName"
  });
}
// 二级市，区，县数据
export function FetchCompanyInfoByCity(data) {
  return request({
    headers: {
      type: "json"
    },
    method: "post",
    url: "/board/home/findCompanyInfoByCity",
    data
  });
}
// 同期省内冷藏车行驶里程对比
export function FetchVehicleDataAnalysis() {
  return request({
    headers: {
      type: "json"
    },
    method: "post",
    url: "/board/home/vehicleDataAnalysis"
  });
}

// 同期省内冷藏车行驶里程对比
export function FetchVehicleData(data) {
  return request({
    headers: {
      type: "json"
    },
    method: "post",
    url: "/board/home/provinceVehicleRunOdomContrast",
    data
  });
}
